<template>
  <div ref='content'>
    <slot />
  </div>
</template>

<script>
import { detachable } from '@/mixins';

export default {
  name: 'Mobile',
  mixins: [detachable('#mobile-panel')],
};
</script>



// WEBPACK FOOTER //
// src/components/Header/Mobile.vue